// Where should a banner / poster / "Shop now" button take the shopper?
//  1. The link the admin saved on the banner (relative path or full URL).
//  2. Otherwise, a sensible page guessed from the banner's own words
//     ("Silk saree" -> sarees, "Kids" -> kids) instead of all products.
//  3. Otherwise, all products.
const GUESSES = [
  [/saree|sari\b|silk/i, '/all-product?subCategory=Saree'],
  [/top\b|tops\b/i, '/all-product?subCategory=Short+Tops'],
  [/kurti|kurta/i, '/all-product?subCategory=Kurti'],
  [/churidar|chudi|salwar/i, '/all-product?subCategory=Churidar+Set'],
  [/night\s*wear|nighty/i, '/all-product?subCategory=Nightwears'],
  [/kid|girl|boy|baby/i, '/all-product?category=KIDS'],
  [/new\s*arrival|new in/i, '/all-product?new=true'],
  [/best\s*seller/i, '/all-product?bestseller=true'],
  [/trend/i, '/all-product?trending=true'],
  [/women|woman|ladies/i, '/all-product?category=WOMEN']
];

export const resolveBannerLink = (link, ...texts) => {
  const raw = String(link || '').trim();
  if (raw) {
    if (/^https?:\/\//i.test(raw)) {
      try {
        const url = new URL(raw);
        if (url.origin === window.location.origin) return url.pathname + url.search;
      } catch (e) {
        /* fall through */
      }
      return raw;
    }
    return raw.startsWith('/') ? raw : `/${raw}`;
  }
  const words = texts.filter(Boolean).join(' ');
  const hit = GUESSES.find(([re]) => re.test(words));
  return hit ? hit[1] : '/all-product';
};

export const openBannerLink = (navigate, link, ...texts) => {
  const target = resolveBannerLink(link, ...texts);
  if (/^https?:\/\//i.test(target)) {
    window.location.href = target;
  } else {
    navigate(target);
  }
};
